module.exports = __webpack_public_path__ + "static/media/boton_pulsante.aba04ee4.gif";